// Autobahn (auto.de redesign) — Gespeicherte Suchen (/my-searches), ADV-267.
//
// Figma "KONTO | 05 Suchen" (desktop 64206:7987 / mobile 64206:8094): breadcrumb back to the
// dashboard, "Neue Suchanfrage" (→ /search) and one card per saved search. Same stores/logic as
// before (filterStore.getSavedSearchStrings, delete/update), only the presentation changed.
// Page-local styles: ./MySearchesNextPage.css.
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import Page from '../../containers/Page';
import SavedSearchCardNext from './SavedSearchQuery/SavedSearchCardNext';
import { Icon } from '@bytebrand/fe-ui-core-autobahn/ui';
import './MySearchesNextPage.css';
let MySearchesNextPage = class MySearchesNextPage extends React.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "handleNewSearchRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => this.props.history.push('/search')
        });
    }
    componentDidMount() { this.props.filterStore.getSavedSearchStrings(); }
    render() {
        const { t, filterStore, notificationStore, history, searchStore, appStore } = this.props;
        const saved = toJS(filterStore.savedSearchStrings);
        const { deleteSavedSearchString, updateSavedSearchString } = filterStore;
        return (React.createElement(Page, { page: "MY_SEARCHES", mainContentClass: "as-main" },
            React.createElement("div", { className: "md3" },
                React.createElement("div", { className: "as-page" },
                    React.createElement("div", { className: "as-top" },
                        React.createElement("nav", { className: "as-crumbs", "aria-label": t('breadcrumbLabel') },
                            React.createElement(Link, { className: "as-crumb-link", to: "/account/dashboard" }, t('dashboard')),
                            React.createElement("span", { className: "as-crumb-sep", "aria-hidden": "true" }, "\u203A"),
                            React.createElement("h1", { className: "as-crumb-current", "aria-current": "page" }, t('mySavedSearchesTitle'))),
                        React.createElement("button", { type: "button", className: "as-new", onClick: this.handleNewSearchRequest }, t('newSearchRequest'))),
                    saved.length ? (React.createElement("div", { className: "as-grid" }, saved.map((s, index) => (React.createElement(SavedSearchCardNext, { key: s._id, index: index, history: history, t: t, addNotification: notificationStore.addNotification, updateSavedSearchString: updateSavedSearchString, deleteSavedSearchString: deleteSavedSearchString, searchStore: searchStore, language: appStore.language, ...s }))))) : (React.createElement("div", { className: "ms-empty" },
                        React.createElement(Icon, { name: "bell", size: 40 }),
                        React.createElement("h3", null, t('noSavedSearches'))))))));
    }
};
MySearchesNextPage = __decorate([
    inject('filterStore', 'notificationStore', 'searchStore', 'appStore'),
    observer
], MySearchesNextPage);
export default translate('SearchSavedPage')(MySearchesNextPage);
